import React from 'react'
import { format, parseISO } from 'date-fns'
import { DateInput } from './DateInput'

export interface DatePickerProps {
  id?: string
  label?: string
  error?: string
  value: Date | null
  onChange: (date: Date | null) => void
  minDate?: Date
  maxDate?: Date
  placeholder?: string
  disabled?: boolean
  dateFormat?: string
  className?: string
  'aria-invalid'?: boolean
  'aria-describedby'?: string
}

/** DatePicker compatibility wrapper backed by the shared shadcn-style DateInput. */
export const DatePicker = React.forwardRef<HTMLInputElement, DatePickerProps>(
  (
    {
      id,
      label,
      error,
      value,
      onChange,
      minDate,
      maxDate,
      placeholder = 'dd/mm/yyyy',
      disabled = false,
      className,
      'aria-invalid': ariaInvalid,
      'aria-describedby': ariaDescribedby,
    },
    ref,
  ): React.ReactElement => (
    <DateInput
      ref={ref}
      id={id}
      label={label}
      error={error}
      value={value ? format(value, 'yyyy-MM-dd') : ''}
      onChange={(event) => {
        const nextValue = event.target.value
        onChange(nextValue ? parseISO(nextValue) : null)
      }}
      min={minDate ? format(minDate, 'yyyy-MM-dd') : undefined}
      max={maxDate ? format(maxDate, 'yyyy-MM-dd') : undefined}
      placeholder={placeholder}
      disabled={disabled}
      className={className}
      aria-invalid={ariaInvalid}
      aria-describedby={ariaDescribedby}
    />
  ),
)

DatePicker.displayName = 'DatePicker'
